/**
 * Soft scroll reveal for page sections.
 * Sections already on screen when the page loads are left alone, so nothing flashes;
 * the rest fade up once as they scroll into view. Skipped for reduced motion.
 */
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reducedMotion && 'IntersectionObserver' in window) {
  const sections = [...document.querySelectorAll('#MainContent > .shopify-section')].filter(
    (section) => section.getBoundingClientRect().top > window.innerHeight
  );

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const section = entry.target;
        observer.unobserve(section);
        section.classList.add('se-in');
        // Drop the classes once settled so no transform lingers on the section
        section.addEventListener(
          'transitionend',
          () => section.classList.remove('se-reveal', 'se-in'),
          { once: true }
        );
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  for (const section of sections) {
    section.classList.add('se-reveal');
    observer.observe(section);
  }
}
